document.addEventListener("turbo:load", () => {
  const container = document.getElementById("required_document_fields");
  if (!container) return;

  const isRequired = container.dataset.required === "true";
  if (!isRequired) return;

  const form = container.closest("form");
  if (!form) return;

  // Capture phase ensures we intercept *before* Turbo
  form.addEventListener(
    "submit",
    (e) => {
      const requiredFiles = [
        { id: "irs_letter_input", label: "IRS Determination Letter" },
        { id: "latest_990_input", label: "Latest Form 990" }
      ];

      const missing = requiredFiles
        .filter(({ id }) => {
          const el = document.getElementById(id);
          return !el || el.files.length === 0;
        })
        .map(({ label }) => label);

      if (missing.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();

        // Disable Turbo drive submission for this form
        form.setAttribute("data-turbo", "false");

        alert(
          `Please upload the following required file${missing.length > 1 ? "s" : ""}:\n- ${missing.join("\n- ")}`
        );

        // Focus first missing button for UX
        const firstButton = container.querySelector("button.btn-outline-primary");
        if (firstButton) firstButton.focus();

        return false;
      }
    },
    true // 👈 capture phase is key
  );
});